import { Typography } from '@mui/material'

export const PreFilterTitle = (): JSX.Element => {
  return <Typography variant="h6">Pre-Filter Cells</Typography>
}

export default PreFilterTitle
